<div *ngIf="otherInformation" class="other-information-section">
    <div *ngFor="let section of otherInformation.sections; let i = index" class="section-item">
        <div class="section-remove">
            <button (click)="removeSection(i)" class="remove-section-btn teia-tt-button">
                <i class="fas fa-trash-alt"></i>
            </button>
        </div>
        <div class="section-title">
            <input type="text" [(ngModel)]="section.title" (ngModelChange)="updateSectionTitle(i, $event)"
                placeholder="Section Title" class="section-title-input" />
        </div>
        <div class="section-body">
            <app-document-editor-menu *ngIf="editors[i]" [editor]="editors[i]" [toolbar]="toolbar">
            </app-document-editor-menu>
            <ngx-editor *ngIf="editors[i]" [editor]="editors[i]" [(ngModel)]="section.value"
                placeholder="Enter text here...">
            </ngx-editor>
        </div>
    </div>
    <div>
        <div class="refresh">
            <app-document-editor-menu [editor]="freeTextEditor" [toolbar]="toolbar">
            </app-document-editor-menu>
            <button (click)="reset()" class="fas fa-undo">
            </button>
        </div>
        <ngx-editor [editor]="freeTextEditor" [(ngModel)]="otherInformation.bottomSection.value"
            (ngModelChange)="onBottomSectionChange($event)">
        </ngx-editor>
    </div>
    <div class="add-section">
        <teiasoft-button class="add-section-btn" [text]="'quotation.addSection' | translate" [theme]="theme"
            [isMobile]="isMobile" (onClick)="addSection()" [disabled]="false"></teiasoft-button>
    </div>
</div>
